export default __webpack_public_path__ + "static/media/image.ccbb9f03.svg";